import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("confirmph_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Thin `fetch` wrapper that injects the auth token so components which
 * prefer the native Fetch API (e.g. for `navigator.sendBeacon` parity)
 * can still hit our authenticated endpoints. Returns the raw Response.
 */
export function authFetch(url, options = {}) {
  const token = localStorage.getItem("confirmph_token");
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(url, { ...options, headers });
}

export function formatApiError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (!detail) {
    if (status === 429) return "Too many requests. Please wait and try again.";
    return err?.message || "Something went wrong";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  // Structured errors: {error_code, message, ...}
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
